import { render, staticRenderFns } from "./cursos.vue?vue&type=template&id=5bc2eb86&scoped=true&"
import script from "./cursos.vue?vue&type=script&lang=ts&"
export * from "./cursos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2eb86",
  null
  
)

export default component.exports